import { requireAuth } from '@/features/auth/guards/require-auth'
import { BomImportPage } from '@/features/bom-import/pages/bom-import-page'
import { messages } from '@/lib/i18n/messages'
import { createFileRoute } from '@tanstack/react-router'
import * as z from 'zod'

// `?project=12` opens the import as «доповнити проєкт 12» — linked from the project.
const searchSchema = z.object({ project: z.coerce.number().int().positive().optional() })

export const Route = createFileRoute('/projects/import')({
  beforeLoad: requireAuth,
  validateSearch: searchSchema,
  component: function ImportRoute() {
    const { project } = Route.useSearch()
    return <BomImportPage initialProjectId={project ?? null} />
  },
  staticData: { crumb: messages.crumbs.projectImport },
})
